import * as axios from '../interceptors/client';
import axiosDownload from "axios";
import { baseURL } from "../interceptors/client";
import { toast } from 'react-toastify';
import { formatMessage } from '../../translations/connectedIntlProvider';
import store from '../store/store';

let config = {
	headers: {
		'Content-Type': 'application/json'
	}
};

let uploadConfig = {
	headers: {
		'Content-Type': 'multipart/form-data'
	}
};

export const get = (url: string) => {
	return axios.baseAPI.get(url, config)
};

export const post = (url: string, data: any) => {
	return axios.baseAPI.post(url, data, config)
};

export const postUpload = (url: string, data: any) => {
	return axios.baseAPI.post(url, data, uploadConfig)
};

export const deleteapi = (url: string) => {
	return axios.baseAPI.delete(url, config)
};

export const deletePostapi = (url: string, data: any) => {
	return axios.baseAPI.delete(url, {
		...config,
		data: data
	})
};

export const downloadCsv = (downloadURL: string, fileName: string) => {

	axiosDownload({
		url: baseURL + downloadURL,
		method: 'GET',
		responseType: 'blob',
		headers: {
			'authorization': 'Bearer ' + store.getState().auth.token
		}

	}).then((response) => {
		const url = window.URL.createObjectURL(new Blob([response.data]));
		const link = document.createElement('a');
		link.href = url;
		// link.setAttribute('download', Date.now() + '.zip');
		link.setAttribute('download', fileName);
		document.body.appendChild(link);
		link.click();
	}).catch((err) => {
		toast.error(formatMessage('Message_Some_Error_Occured'));
	});
}

export const downloadCsvPost = (downloadURL: string, downloadData: any) => {

	axiosDownload({
		url: baseURL + downloadURL,
		method: 'POST',
		responseType: 'blob',
		headers: {
			'authorization': 'Bearer ' + store.getState().auth.token
		},
		data: downloadData
	}).then((response) => {
		const url = window.URL.createObjectURL(new Blob([response.data]));
		const link = document.createElement('a');
		link.href = url;
		link.setAttribute('download', Date.now() + '.zip');
		document.body.appendChild(link);
		link.click();
	}).catch((err) => {
		toast.error(formatMessage('Message_Some_Error_Occured'));
	});
}